import { useMediaQuery } from "react-responsive";

export const useMediaQueries = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isMobileOrTablet = useMediaQuery({ query: "(max-width: 1023px)" });
  const isDesktop = useMediaQuery({ query: "(min-width: 1024px)" });

  return { isMobile, isMobileOrTablet, isDesktop };
};
